import React, { memo, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import {Card, CardContent, Typography, IconButton,
  Avatar, Box, Backdrop, CardMedia} from '@mui/material';
import backstaff1 from '../../other/image/back_staff1.jpg';
import img1 from '../../other/image/back_rand1.jpg';
import img2 from '../../other/image/back_rand2.jpg';
import img3 from '../../other/image/back_rand3.jpg';
import img4 from '../../other/image/back_rand4.jpg';
import img5 from '../../other/image/back_rand5.jpg';
import img6 from '../../other/image/back_rand6.jpg';
import { getImage } from '../utils/datautils';

const Title = styled(Typography)(({theme}) => ({
  width: "70%",
  borderRadius: '10px',
  textAlign: 'center',
  paddingTop: '1vw',
  color: '#1b4f59',
  background: 'white',
  fontFamily: 'Helvetica',
}))

const ImgAvt = styled(Avatar)(({theme}) => ({
  width: '15vh',
  height: '15vh',
  fontSize: '3rem',
  marginTop: '15px',
  marginBottom: '10px',
  border: '10px solid #b0b0b0',
  [theme.breakpoints.up('md')]:{
    width: '10vw',
    height: '10vw',
    fontSize: '4rem',
    marginTop: '35px',
    marginBottom: '25px',
    border: '15px solid #b0b0b0'
  }
}))

const Motivation = styled(Typography)(({theme}) => ({
  color: 'white',
  border: '3px solid white',
  borderRadius: '10px',
  margin: '5px',
  width:'95%',
  padding: '0 15px 0 15px',
  fontFamily: 'Times New Roman',
  textAlign: 'center'
}))

const Body1 = styled(Typography)(({theme}) => ({
  fontFamily: 'Verdana',
  fontWeight: 700
}))

const Body2 = styled(Typography)(({theme}) => ({
  fontFamily: 'Georgia',
  color: '#1b4f59',
}))

const Body3 = styled(Typography)(({theme}) => ({
  marginTop: '4px',
  [theme.breakpoints.up(500)]:{
    marginTop: '25px',
  }
}))

const Back = styled(Backdrop)(({theme}) => ({
  zIndex: theme.zIndex.drawer + 1,
  position:'fixed',
  color: '#fff'
}))

export const StaffContainer = memo(({image,name,tahun,departemen,jabatan,motivasi,facebook,instagram,setError}) => {
  const [open, setOpen] = useState(false);
  const [img,setImg] = useState();
  const [backImg,setBackImg] = useState('')
  const back = [img1,img2,img3,img4,img5,img6]
  useEffect(() => {
    setBackImg(back[Math.round(Math.random()*5)])
  },[])
  useEffect(() => {
    if (image && image.length > 0) 
      getImage(image).then(url => {setImg(url)}).catch(err => {setError(err.message)})
  },[image])
  const handleClose = () => {
    setOpen(false);
  };
  const handleClick = () => {
    setOpen(!open);
  };
  const imagess = (
    <Back open={open} onClick={handleClose}>
      <img src={img} style={{transform: 'scale(0.5,0.5)'}} alt={name}/>
    </Back>
  )

  return(
    <>
      <Card elevation={5} sx={{borderRadius: 15,width:'95vw',maxWidth:'600px',margin:'10px'}}>
        <CardMedia alt="back" image={backstaff1}>
          <Box style={{justifyContent:"center",alignItems:'center', display:'flex',paddingTop:"20px",paddingBottom:"20px"}}>
            <Title variant='h5'>
              <b>{name}</b>
            </Title>
          </Box>
        </CardMedia>
        <CardMedia alt='back2' image={backImg}>
          <CardContent>
            <Box style={{justifyContent:"center",alignItems:'center',display:'flex'}}>
              <Body3 variant='h6' textAlign='center' sx={{background:'rgba(255,255,255,.8)',padding:'0px 10px 0px 10px',borderRadius:'5px 5px 0 0'}}>
                {(tahun !== new Date().getFullYear())? (<strong>Info Alumni:</strong>):(<strong>Info Staff:</strong>)}
              </Body3>
            </Box>
            <Box justifyContent="center" alignItems='center' display='flex'>
              <Box sx={{background:'rgba(255,255,255,.8)',padding:'10px',borderRadius:'5px'}}>
                <table>
                  <tr>
                    <td><Body1 variant='body2'>Departemen</Body1></td>
                    <td><Body1 variant='body2'>:</Body1></td>
                    <td><Body2 variant='body1'>{departemen}</Body2></td>
                  </tr>
                  <tr>
                    <td><Body1 variant='body2'>Jabatan</Body1></td>
                    <td><Body1 variant='body2'>:</Body1></td>
                    <td><Body2 variant='body1'>{jabatan}</Body2></td>
                  </tr>
                  <tr>
                    {
                      (tahun !== new Date().getFullYear())?(
                        <>
                          <td><Body1 variant='body2'>Periode</Body1></td>
                          <td><Body1 variant='body2'>:</Body1></td>
                          <td><Body2 variant='body1'>{tahun}</Body2></td>
                        </>
                      ):(<></>)
                    }
                  </tr>
                </table>
              </Box>
            </Box>
            <Box justifyContent="center" alignItems='center' display='flex'>
              <Box>
                {(img !== null)? (
                  <ImgAvt src={img} onClick={handleClick}/>
                ):(
                  <ImgAvt style={{backgroundColor: ''}}>{name.charAt(0)}</ImgAvt>
                )}
              </Box>
            </Box>
            <Box sx={{background: '#595959',display:'flex',justifyContent:'center',borderRadius: '10px 10px 0 0'}}>
              <Motivation variant='body1'>
                " {motivasi} "
              </Motivation>
            </Box>
            <Box justifyContent="center" alignItems='center' display='flex' style={{color: 'white', marginBottom:'10px',background:'rgba(0,0,0,.8)',borderRadius: '0 0 10px 10px'}}>
                {
                  (facebook.length !== 0)? (
                    <IconButton target='_blank' color='inherit' href={'https://facebook.com/'+facebook}><FacebookIcon/></IconButton>
                  ):(<></>)
                }
                {
                  (instagram.length !== 0)?(
                    <IconButton target='_blank' color='inherit' href={'https://instagram.com/'+instagram}><InstagramIcon/></IconButton>
                  ):(<></>)
                }
            </Box>
          </CardContent>
        </CardMedia>
      </Card>
      {imagess}
    </>
  )
})
